<template>
  <div class="flex flex-row">
    <IconField iconPosition="left" class="text-lg w-2/3 md:w-96">
      <InputIcon class="pi pi-search text-base text-primary-500! font-extrabold"> </InputIcon>
      <InputText
        v-model="searchText"
        placeholder="Search"
        :class="showRefresh ? 'rounded-r-none!' : ''"
        class="h-10 w-full"
        @input="$emit('input')"
      />
    </IconField>
    <RefreshButton v-if="showRefresh" @click="emit('refresh')"></RefreshButton>
  </div>
</template>

<script setup lang="ts">
const searchText = defineModel<string>("searchText", { required: true });

const emit = defineEmits<{
  input: [];
  refresh: [];
}>();

interface Props {
  showRefresh: boolean;
}
const props = defineProps<Props>();
</script>
